import { tripTemplate } from '@/dataStructures';

const errors = () => ({
	isInvalid: false,
	name: undefined,
	eta: undefined,
	etd: undefined,
	fromAddress: undefined,
	toAddress: undefined,
	vendor: undefined,
	legs: [{}],
});

export { errors };

export default {
	loading: false,
	tripTemplates: [],
	generatedTrips: [],
	templateDetails: tripTemplate(),
	dirty: false,
	errors: errors(),
};